import { COOKIE_JWT, COOKIE_MAX_AGE } from "@magnit/util-auth/src/constants/cookie";
import {
  IProfileIncompleteCookieEnum,
} from "@magnit/layer-api/typings/cookies";

export default defineNuxtRouteMiddleware(async (to) => {
  const pinia = usePinia();
  const jwt = useCookie<IJWT | null>(COOKIE_JWT, {
    httpOnly: false,
    maxAge: COOKIE_MAX_AGE,
  });
  const userStore = useUserStore(pinia);
  const { apiCheckProfile } = useAuth({ skipLifeCycleHooks: true });
  const { profileIncompleteState } = useAuthCookies();
  /*
  / Если пользователь авторизован, запрашиваем данные профиля
  */
  if (jwt.value && userStore.status.profile !== "success") {
    await userStore.getProfile();
  }
  /*
  / Проверка валидности профиля
  */
  if (jwt.value) {
    if (!to.fullPath.includes(Routes.ProfileIncomplete)) {
      if (!profileIncompleteState.value ||
        profileIncompleteState.value === IProfileIncompleteCookieEnum.incomplete) {
        await apiCheckProfile();
      }
      await nextTick(() => {
        if (profileIncompleteState.value === IProfileIncompleteCookieEnum.incomplete) {
          return navigateTo(Routes.ProfileIncomplete);
        }
      });
    } else if (profileIncompleteState.value === IProfileIncompleteCookieEnum.valid) {
      return navigateTo(Routes.Main);
    }
  } else if ((profileIncompleteState.value === IProfileIncompleteCookieEnum.valid)) {
    profileIncompleteState.value = null;
  }
});
